type TableElemProps = {
  name: string;
  children: React.ReactNode;
};

export const TableElem = ({ name, children }: TableElemProps) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-gray-500">{name}</span>
      {children}
    </div>
  );
};
